__turbopack_context__.v({
  "bentoContent": "Rh4gTW_bentoContent",
  "bentoImage": "Rh4gTW_bentoImage",
  "bentoWrapper": "Rh4gTW_bentoWrapper",
  "canvas": "Rh4gTW_canvas",
  "container": "Rh4gTW_container",
  "customSubtitleWrapper": "Rh4gTW_customSubtitleWrapper",
  "fallbackImage": "Rh4gTW_fallbackImage",
  "gradientSection": "Rh4gTW_gradientSection",
  "gradientSequenceContainer": "Rh4gTW_gradientSequenceContainer",
  "overlayInner": "Rh4gTW_overlayInner",
  "sequenceCanvas": "Rh4gTW_sequenceCanvas",
  "sequenceStickyWrapper": "Rh4gTW_sequenceStickyWrapper",
  "shootingStarsContainer": "Rh4gTW_shootingStarsContainer",
  "stickyInner": "Rh4gTW_stickyInner",
  "stickyOverlayAbs": "Rh4gTW_stickyOverlayAbs",
});
